import Vue from "vue";
import Router from "vue-router";
import Dashboard from "@/components/admin/Dashboard";
import AppNotFound from "@/common/layout/pages/AppNotFound";
import AppForbidden from "@/common/layout/pages/AppForbidden";
import AppError from "@/common/layout/pages/AppError";
import AppPermission from "@/common/layout/pages/AppPermission";
import SinPermiso from "@/common/layout/pages/SinPermiso"

// System
import Login from "@/components/admin/auth/Login";
import PasswordRecovery from "@/components/admin/auth/PasswordRecovery";
//import LoginLock from "@/components/admin/auth/LoginLock";
import Account from "@/components/admin/account/Account";
import Usuario from "@/components/admin/usuario/Usuario";
import RolRecurso from "@/components/admin/rol-recurso/Index";
import Log from "@/components/admin/Log";
import UsuarioSistema from "@/components/admin/usuario_sistema/Usuario";

import Parametro from "@/components/admin/parametro/Index";

//PUESTOS ITEMS CARGOS
import Puestos from '@/components/admin/item_cargo_y_puesto/Puestos.vue'
import Cargo from '@/components/admin/item_cargo_y_puesto/Cargo'
import ItemCargoPuesto from '@/components/admin/item_cargo_y_puesto/ItemCargoPuesto'
import Unidad from '@/components/admin/item_cargo_y_puesto/Unidad'

// RRHH
import Persona from '@/components/admin/persona/Index';
import Personal from '@/components/admin/persona/Index2';
import Movilidad from '@/components/admin/movilidad/Movilidad';
import MovilidadFuncionario from '@/components/admin/movilidad/MovilidadFuncionario';
import ListaPersonal from '@/components/admin/movilidad/Index';
import ConsultaMovilidad from '@/components/admin/movilidad/ConsultaMovilidad';
import Horario from '@/components/admin/horario/Index';
import FichaPersonal from '@/components/admin/ficha_personal/Index'
import Item from '@/components/admin/item/Index';
import Turno from '@/components/admin/turno/Index';
import AsignacionTurno from '@/components/admin/asignacion_horario/Index';
import TipoPermiso from '@/components/admin/tipo_permiso/Index';
import Permiso from '@/components/admin/permiso/Permiso';
import PermisoRRHH from '@/components/admin/permiso/PermisoRRHH';
import PermisoJefeAprobacion from '@/components/admin/permiso/PermisoJefeAprobacion';
import PermisoDirectorAprobacion from '@/components/admin/permiso/PermisoDirectorAprobacion';
import PermisoCrear from '@/components/admin/permiso/PermisoCrear';
import PermisoCrearRRHH from '@/components/admin/permiso/PermisoCrearRRHH';
import ReportePermisos from '@/components/admin/permiso/ReportePermisos';

import Asistencia from '@/components/admin/asistencia/Index';
import Planillas from '@/components/admin/asistencia/Planillas';
import AsistenciaFuncionario from '@/components/admin/asistencia/AsistenciaFuncionario';
import AsistenciaResumen from '@/components/admin/asistencia/AsistenciaResumen'
import AsistenciaTipificacion from '@/components/admin/asistencia/AsistenciaTipificacion'
import ReportePlanillasGeneral from '@/components/admin/asistencia/ReportePlanillasGeneral';
import FichaPersonalRrhh from '@/components/admin/ficha_personal/Index'
import VlistaFichaRevision from '@/components/admin/v_listaficha/Index'
import VlistaFichaAprobar from '@/components/admin/v_listasfichaprobar/Index'
import RegistroManualAsistencia from '@/components/admin/registro_manual_asistencia/Index';
import ListadoRegistroAsistenciaManual from '@/components/admin/registro_manual_asistencia/ListadoRegistrosAsistenciaManual.vue';
import CrearRegistroAsistenciaManual from '@/components/admin/registro_manual_asistencia/CrearRegistroAsistenciaManual.vue';
import ModificarRegistroAsistenciaManualF from '@/components/admin/registro_manual_asistencia/ModificarRegistroAsistenciaManualF.vue';
import ListadoRegistroAsistenciaManualAutoridad from '@/components/admin/registro_manual_asistencia/ListadoRegistrosAsistenciaManualAutoridad.vue';
import CrearRegistroAsistenciaManualAutoridad from '@/components/admin/registro_manual_asistencia/CrearRegistroAsistenciaManualAutoridad.vue';
import EditarRegistroAsistenciaManualAutoridad from '@/components/admin/registro_manual_asistencia/EditarRegistroAsistenciaManualAutoridad.vue';
import LecturaArchivos from '@/components/admin/lectura_archivos/Index'

// COMISION VIAJE
import ComisionViaje from '@/components/admin/comision_viaje/ListadoFuncionarios.vue';
import ListadoViajeDetalle from '@/components/admin/comision_viaje/ListadoViajeDetalle.vue';
import ListadoViajeDetalleConsulta from '@/components/admin/comision_viaje/ListadoViajeDetalleConsulta.vue';

//INCREMENTO SALARIAL:
import IncrementoSalarial from '@/components/admin/incremento_salarial/Index';

//APROBACION CAS 
import AprobacionCas from '@/components/admin/lista_personal_cas/Index';

//VACACIONES
import Vacaciones from '@/components/admin/vacaciones/Index'
import Programar from '@/components/admin/vacaciones/Programar';
import VacacionesAprobar from '@/components/admin/vacaciones_aprobar/Index'
import VacacionesAprobarRrhh from '@/components/admin/vacaciones_aprobar/VacacionesAprobarRrhh'
import VacacionesAprobarJefe1 from '@/components/admin/vacaciones/VacacionAprobarJefe1'
import VacacionesAprobarJefe2 from '@/components/admin/vacaciones/VacacionAprobarJefe2'
import VacacionesReporteFuncionario from '@/components/admin/vacaciones/ReporteVacacionesFuncionario'
//VACACIONES RRHH
import ListadoFuncionariosRRHHVacaciones from '@/components/admin/vacacion_rrhh/ListadoFuncionariosRRHHVacaciones'
import VacacionesGestionRRHH from '@/components/admin/vacacion_rrhh/VacacionesGestionRRHH'
import ProgramacionesPorFuncionario from '@/components/admin/vacacion_rrhh/ProgramacionesPorFuncionario'
import VacacionesListadoUnidades from '@/components/admin/vacacion_rrhh/VacacionesListadoUnidades'
import ListadoPersonasVacacionesRRHH from '@/components/admin/vacacion_rrhh/ListadoPersonasVacacionesRRHH'
import VacacionesProgramadasPorServidorRRHH from '@/components/admin/vacacion_rrhh/VacacionesProgramadasPorServidorRRHH'
import VacacionRRHH from '@/components/admin/vacaciones/VacacionRRHH'
import ParametrosVacacion from '@/components/admin/parametros_vacacion/Index.vue'
import CronogramaVacaciones from '@/components/admin/vacaciones/CronogramaVacaciones.vue'
import CronogramaVacaciones2 from '@/components/admin/vacaciones/CronogramaVacaciones2.vue'
import ListadoGestionesPorUnidad from '@/components/admin/vacaciones/ListadoGestionesPorUnidad'
import ListadoGestionesPorServidor from '@/components/admin/vacaciones/ListadoGestionesPorServidor'
import VerDetalleProgramacionJerarquico from '@/components/admin/vacaciones/VerDetalleProgramacionJerarquico'

//USO DE VACACIONES  vacacion_uso
import VacacionesUsoFuncionario from '@/components/admin/vacacion_uso/Index'
import VacacionUsoJefeInmediato from '@/components/admin/vacacion_uso/VacacionUsoJefeInmediato'
import VacacionUsoJefeSuperior from '@/components/admin/vacacion_uso/VacacionUsoJefeSuperior'

//REPROGRAMACION DE VACACIONES  REPROGRAMACION 
import VacacionReprogramacionFuncionario from '@/components/admin/vacacion_reprogramacion/Funcionario'
import VacacionReprogramacionJefeSuperior from '@/components/admin/vacacion_reprogramacion/VacacionReprogramacionJefeSuperior'
import VacacionReprogramacionJefeInmediato from '@/components/admin/vacacion_reprogramacion/VacacionReprogramacionJefeInmediato'

//papeleta de solicitud de vacacion
import PapeletaVacacion from '@/components/admin/papeleta_vacacion/Index'
import AprobacionPapeletaVacacionJefeSuperior from '@/components/admin/papeleta_vacacion/AprobacionPapeletaVacacionJefeSuperior'
import AprobacionPapeletaVacacionJefeInmediato from '@/components/admin/papeleta_vacacion/AprobacionPapeletaVacacionJefeInmediato'

//FERIADOS
import Feriado from '@/components/admin/feriado/Index'

// REPORTES
import ReporteVacaciones from "@/components/admin/reportes/ReporteVacaciones.vue"

// Tipificacion
import AjusteTipificacion from "@/components/admin/tipificacion/AjusteTipificacion"
import DetalleRefrigerioFuncionario from "@/components/admin/asistencia/DetalleRefrigerioFuncionario"

// Modulo de pasantes
import AsistenciaTipificacionPasantes from "@/components/admin/pasantes/AsistenciaTipificacion"

// Reportes varios como listado de personal
import ListaPersonalActivo from "@/components/admin/reportes_lista_personal/ListaPersonalActivo.vue"

import Varios from "@/components/admin/varios/Varios.vue";
// import ProgramarVacacion from '@/components/admin/vacaciones/Index2'
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/password-recovery',
            name: 'PasswordRecovery',
            component: PasswordRecovery
        },
        /*{
            path: '/loginlock',
            name: 'LoginLock',
            component: LoginLock
        },*/

        {
            path: '/usuarios',
            name: 'Usuario',
            component: Usuario
        },
        {
            path: '/roles',
            name: 'RolRecurso',
            component: RolRecurso
        },
        {
            path: '/account',
            name: 'Account',
            component: Account
        },
        {
            path: '/parametros',
            name: 'Parametro',
            component: Parametro
        },
        {
            path: '/logs',
            name: 'Logs',
            component: Log
        },
        {
            path: '/ficha-personal',
            name: 'FichaPersonal',
            component: FichaPersonal
        },
        {
            path: '/ficha-personal-revision',
            name: 'VlistaFicha',
            component: VlistaFichaRevision
        },
        {
            path: '/ficha-personal-aprobacion',
            name: 'VlistaFichaAprobar',
            component: VlistaFichaAprobar
        },
        {
            path: '/usuario-sistema',
            name: 'UsuarioSistema',
            component: UsuarioSistema
        },
        //ItemCargoPuesto  
        {
            path: '/puesto',
            name: 'Puestos',
            component: Puestos
        },
        {
            path: '/cargo',
            name: 'Cargo',
            component: Cargo
        },
        {
            path: '/item-cargo-puesto',
            name: 'ItemCargoPuesto',
            component: ItemCargoPuesto
        },
        {
            path: '/unidad',
            name: 'Unidad',
            component: Unidad
        },
        // Asistencia
        {
            path: '/asistencia',
            name: 'Asistencia',
            component: Asistencia
        },
        {
            path: '/planillas',
            name: 'Planillas',
            component: Planillas
        },
        // Reportes
        {
            path: '/reporte-vacacion',
            name: 'ReporteVacaciones',
            component: ReporteVacaciones
        },
        // Vacaciones
        {
            path: '/parametros-vacacion',
            name: 'ParametrosVacacion',
            component: ParametrosVacacion
        },
        {
            path: '/vacaciones-aprobar',
            name: 'VacacionesAprobar',
            component: VacacionesAprobar
        },
        {
            path: '/vacaciones-aprobar-jefe-inmediato/:gestion',
            name: 'VacacionesAprobarJefe1',
            component: VacacionesAprobarJefe1
        },
        {
            path: '/ver-detalle-programacion-jerarquico/:gestion/:id_unidad/:nombre_unidad/:item_jefe',
            name: 'VerDetalleProgramacionJerarquico',
            component: VerDetalleProgramacionJerarquico
        },
        {
            path: '/vacaciones-aprobar-jefe-superior/:gestion',
            name: 'VacacionesAprobarJefe2',
            component: VacacionesAprobarJefe2
        },
        //VACACIONES RRHH
        {
            path: '/listado-funcionarios-RRHH-vacaciones/:gestion/:item_jefe/:id_unidad/:tipo_jefe/:id_persona',
            name: 'ListadoFuncionariosRRHHVacaciones',
            component: ListadoFuncionariosRRHHVacaciones
        },
        {
            path: '/vacaciones-gestion-RRHH',
            name: 'VacacionesGestionRRHH',
            component: VacacionesGestionRRHH
        },
        {
            path: '/programacion-funcionario-RRHH/:gestion/:id_persona',
            name: 'ProgramacionesPorFuncionario',
            component: ProgramacionesPorFuncionario
        },
        {
            path: '/vacaciones-listado-unidades/:gestion',
            name: 'VacacionesListadoUnidades',
            component: VacacionesListadoUnidades
        },
        {
            path: '/vacaciones-RRHH/:id_persona',
            name: 'VacacionRRHH',
            component: VacacionRRHH
        },
        {
            path: '/vacaciones-aprobar-rrhh',
            name: 'VacacionesAprobarRrhh',
            component: VacacionesAprobarRrhh
        },
        {
            path: '/cronograma-vacaciones-rrhh',
            name: 'CronogramaVacaciones',
            component: CronogramaVacaciones
        },
        {
            path: '/cronograma-vacaciones-rrhh2',
            name: 'CronogramaVacaciones2',
            component: CronogramaVacaciones2
        },
        {
            path: '/vacaciones',
            name: 'Vacaciones',
            component: Vacaciones
        },
        {
            path: '/programar/:gestion',
            name: 'Programar',
            component: Programar
        },
        {
            path: '/reporte-vacaciones-funcionario',
            name: 'VacacionesReporteFuncionario',
            component: VacacionesReporteFuncionario
        },

        {
            path: '/vacaciones-uso-funcionario',
            name: 'VacacionesUsoFuncionario',
            component: VacacionesUsoFuncionario
        },
        {
            path: '/vacaciones-uso-jefe-inmediato',
            name: 'VacacionUsoJefeInmediato',
            component: VacacionUsoJefeInmediato
        },
        {
            path: '/vacaciones-uso-jefe-superior',
            name: 'VacacionUsoJefeSuperior',
            component: VacacionUsoJefeSuperior
        },

        {
            path: '/vacaciones/RRHH',
            name: 'ListadoPersonasVacacionesRRHH',
            component: ListadoPersonasVacacionesRRHH
        },
        {
            path: '/vacaciones-programadas-rrhh/:id_persona',
            name: 'VacacionesProgramadasPorServidorRRHH',
            component: VacacionesProgramadasPorServidorRRHH
        },
        {
            path: '/vacacion-reprogramacion-funcionario',
            name: 'VacacionReprogramacionFuncionario',
            component: VacacionReprogramacionFuncionario
        },
        {
            path: '/vacacion-reprogramacion-inmediato',
            name: 'VacacionReprogramacionJefeInmediato',
            component: VacacionReprogramacionJefeInmediato
        },
        {
            path: '/vacacion-reprogramacion-superior',
            name: 'VacacionReprogramacionJefeSuperior',
            component: VacacionReprogramacionJefeSuperior
        },
        //----------------------------------
        //papeletas de vacacion
        {
            path: '/papeleta-vacacion',
            name: 'PapeletaVacacion',
            component: PapeletaVacacion
        },
        {
            path: '/papeleta-vacacion-jefe-superior',
            name: 'AprobacionPapeletaVacacionJefeSuperior',
            component: AprobacionPapeletaVacacionJefeSuperior
        },
        {
            path: '/papeleta-vacacion-jefe-inmediato',
            name: 'AprobacionPapeletaVacacionJefeInmediato',
            component: AprobacionPapeletaVacacionJefeInmediato
        },
        //-------------------------------
        {
            path: '/asistencia-funcionario',
            name: 'AsistenciaFuncionario',
            component: AsistenciaFuncionario
        },
        {
            path: '/asistencia-resumen',
            name: 'AsistenciaResumen',
            component: AsistenciaResumen
        },
        {
            path: '/asistencia-tipificacion',
            name: 'AsistenciaTipificacion',
            component: AsistenciaTipificacion
        },
        {
            path: '/planillas/reporte',
            name: 'ReportePlanillasGeneral',
            component: ReportePlanillasGeneral
        },
        {
            path: '/persona/datos-personales',
            name: 'Persona',
            component: Persona
        },
        {
            path: '/persona/movilidad',
            name: 'ListaPersonal',
            component: ListaPersonal
        },
        {
            path: '/movilidad-servidor-publico',
            name: 'MovilidadFuncionario',
            component: MovilidadFuncionario
        },
        {
            path: '/personas',
            name: 'Personal',
            component: Personal
        },
        {
            path: '/personas/ficha-personal/:id',
            name: 'FichaPersonalRrhh',
            component: FichaPersonalRrhh
        },
        {
            path: '/movilidad/:id',
            name: 'Movilidad',
            component: Movilidad
        },
        {
            path: '/consulta-movilidad',
            name: 'ConsultaMovilidad',
            component: ConsultaMovilidad
        },
        // Permisos
        {
            path: '/tipo-permisos',
            name: 'TipoPermiso',
            component: TipoPermiso
        },
        {
            path: '/permisos/usuario',
            name: 'Permiso',
            component: Permiso
        },
        {
            path: '/permisos/usuario/:id',
            name: 'PermisoRRHH',
            component: Permiso
        },
        {
            path: '/permisos/rrhh',
            name: 'PermisoRRHH',
            component: PermisoRRHH
        },
        {
            path: '/permisos/jefe-aprobacion',
            name: 'PermisoJefeAprobacion',
            component: PermisoJefeAprobacion
        },
        {
            path: '/permisos/director-aprobacion',
            name: 'PermisoDirectorAprobacion',
            component: PermisoDirectorAprobacion
        },
        {
            path: '/permisos/crear',
            name: 'PermisoCrear',
            component: PermisoCrear
        },
        {
            path: '/permisos/crearRRHH/:id',
            name: 'PermisoCrearRRHH1',
            component: PermisoCrearRRHH
        },
        {
            path: '/permisos/reporte',
            name: 'ReportePermisos',
            component: ReportePermisos
        },
        {
            path: '/permisos/crear/:id',
            name: 'PermisoCrearRRHH',
            component: PermisoCrear
        },
        {
            path: '/horarios',
            name: 'Horario',
            component: Horario
        },
        {
            path: '/items',
            name: 'Item',
            component: Item
        },
        {
            path: '/turnos',
            name: 'Turno',
            component: Turno
        },
        {
            path: '/asignacion-turnos',
            name: 'AsignacionTurno',
            component: AsignacionTurno
        },
        {
            path: '/registro-manual-asistencia',
            name: 'RegistroManualAsistencia',
            component: RegistroManualAsistencia
        },
        {
            path: '/registro-manual-asistencia/listado/:id',
            name: 'ListadoRegistroAsistenciaManual',
            component: ListadoRegistroAsistenciaManual
        },
        {
            path: '/registro-manual-asistencia/crear/:id',
            name: 'CrearRegistroAsistenciaManual',
            component: CrearRegistroAsistenciaManual
        },
        {
            path: '/registro-manual-asistencia/modificar/:id_persona/:id_cabecera',
            name: 'ModificarRegistroAsistenciaManualF',
            component: ModificarRegistroAsistenciaManualF
        },
        {
            path: '/registro-manual-asistencia-autoridad/listado/:id',
            name: 'ListadoRegistroAsistenciaManualAutoridad',
            component: ListadoRegistroAsistenciaManualAutoridad
        },
        {
            path: '/registro-manual-asistencia-autoridad/crear/:id',
            name: 'CrearRegistroAsistenciaManualAutoridad',
            component: CrearRegistroAsistenciaManualAutoridad
        },
        {
            path: '/registro-manual-asistencia-autoridad/editar/:id_persona/:id_cabecera',
            name: 'EditarrRegistroAsistenciaManualAutoridad',
            component: EditarRegistroAsistenciaManualAutoridad
        },
        {
            path: '/comision-viaje',
            name: 'ComisionViaje',
            component: ComisionViaje
        },
        {
            path: '/comision-viaje/detalle/:id_persona',
            name: 'ListadoViajeDetalle',
            component: ListadoViajeDetalle
        },
        {
            path: '/comision-viaje/detalle-consulta/:ci',
            name: 'ListadoViajeDetalleConsulta',
            component: ListadoViajeDetalleConsulta
        },
        //increento salaraial 
        {
            path: '/incremento-salarial',
            name: 'IncrementoSalarial',
            component: IncrementoSalarial
        },
        //aprobacion cas 
        {
            path: '/aprobacion-cas',
            name: 'AprobacionCas',
            component: AprobacionCas
        },

        {
            path: '/gestiones-vacacion-unidad',
            name: 'ListadoGestionesPorUnidad',
            component: ListadoGestionesPorUnidad
        },
        {
            path: '/gestiones-vacacion-funcionario',
            name: 'ListadoGestionesPorServidor',
            component: ListadoGestionesPorServidor
        },

        //solo lectura de archivos  
        {
            path: '/lectura-archivos/ficha-personal',
            name: 'LecturaArchivos',
            component: LecturaArchivos
        },
        // Listado de personal autoridad
        {
            path: '/lista-personal-autoridad',
            name: 'ListaPersonalActivo',
            component: ListaPersonalActivo
        },

        //FERIADOS
        {
            path: '/feriado',
            name: 'Feriado',
            component: Feriado
        },
        // TIPIFICACION
        {
            path: '/ajuste-tipificacion/:id_persona',
            name: 'AjusteTipificacion',
            component: AjusteTipificacion
        },
        {
            path: '/detalle-refrigerio/:id_persona/:mes/:gestion',
            name: 'DetalleRefrigerioFuncionario2',
            component: DetalleRefrigerioFuncionario
        },
        {
            path: '/detalle-refrigerio',
            name: 'DetalleRefrigerioFuncionario',
            component: DetalleRefrigerioFuncionario
        },
        // MOodulo de pasantes
        {
            path: '/asistencia-pasantes',
            name: 'AsistenciaTipificacionPasantes',
            component: AsistenciaTipificacionPasantes
        },
        
        // Páginas globales
        {
            path: '/404',
            component: AppNotFound
        },
        {
            path: '/403',
            component: AppForbidden
        },
        {
            path: '/401',
            component: AppPermission
        },
        {
            path: '/500',
            component: AppError
        },
        {
            path: '*',
            component: AppNotFound
        },
        {
            path: '/accion-no-permitida',
            component: SinPermiso
        },
        {
            path: '/prueba-varios',
            component: Varios
        },
        

    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js